import React, { VFCX } from 'react';
import styled from '@emotion/styled';

import { Button } from 'src/components/common/atoms';

// this form works only Netlify

const Component: VFCX = ({ className }) => (
  <form className={className} name='contact' method='POST' data-netlify='true' data-netlify-honeypot='bot-field'>
    <input type='hidden' name='form-name' value='contact' />
    <input type='hidden' name='bot-field' />

    <div>
      <label htmlFor='name'>
        <p>
          name<abbr title='required'>*</abbr>
        </p>

        <input
          type='text'
          className='form-control'
          name='name'
          placeholder='お名前・法人名'
          maxLength={30}
          minLength={2}
          required
          autoComplete='name'
        />
      </label>

      <label htmlFor='mail'>
        <p>
          mail<abbr title='required'>*</abbr>
        </p>

        <input
          type='email'
          name='email'
          placeholder='メールアドレス'
          pattern="^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
          required
          autoComplete='email'
        />
      </label>
    </div>

    <div>
      <label htmlFor='message'>
        <p>message</p>
        <abbr title='required' />
        <textarea name='content' rows={8} required />
      </label>
    </div>

    <Button type='submit' bg='var(--color-secondary-light)'>
      SUBMIT
    </Button>
  </form>
);

const StyledComponent = styled(Component)`
  position: relative;

  max-width: 1000px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  div {
    display: flex;
    width: 100%;
    flex-direction: column;

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }

    label {
      flex-grow: 1;
    }
  }

  label {
    padding: 1rem;
    width: 100%;
  }

  p {
    color: var(--color-text-inverse);
    font-size: 2rem;
    font-weight: 600;
    display: block;
    margin-bottom: 1rem;
  }

  input,
  textarea {
    outline: 0;
    width: 100%;
    background-color: transparent;
    border-radius: 4px;
    color: #555;
    padding: 0.7em;
    border: 1px solid var(--color-text-inverse);
  }

  @media screen and (min-width: 480px) {
  }
  @media screen and (min-width: 768px) {
  }
  @media screen and (min-width: 1024px) {
  }
`;

export default StyledComponent;
